import { makeStyles } from "tss-react/mui";

export const SubHeaderStyle = makeStyles()(
    (theme, p, classes) => ({
        container: {
            fontSize: 16,
            "& .MuiButton-root": {
                fontSize: 16
            }
        }
    })
);
